export default __webpack_public_path__ + "static/media/dartboard.5515dfbd.svg";